import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

const INITIAL_NUMBER_OF_OPTIONS = 4

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    /**
     * TODO:
     */
    registerNewActiveElement: store.actions.standalone({
      // NOTE: must be callback to avoid NgRx freezing the object
      data: (activeElement: () => Document['activeElement']) =>
        activeElement ?? undefined,
      reducer: ({ state, data }): State => {
        const element = data()
        // Captures the active element at this point in time
        const editor =
          element instanceof HTMLInputElement ||
          element instanceof HTMLTextAreaElement
            ? () => element
            : undefined
        return {
          ...state,
          editor: editor ?? state.editor,
          changesInFocusSinceEditorWasActive: editor
            ? 0
            : state.changesInFocusSinceEditorWasActive + 1,
        }
      },
    }),
    /**
     * TODO:
     */
    initiate: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => ({
        ...state,
        // We expect one change in focus (clicking a button to initiate this).
        // If there has been more than 1, then the user is no longer using the
        // editor, and we should get rid of it
        editor:
          state.changesInFocusSinceEditorWasActive <= 1
            ? state.editor
            : undefined,
        enhancementTypeCurrentOptionsSelector: INITIAL_NUMBER_OF_OPTIONS,
      }),
    }),
    /**
     * TODO:
     */
    quit: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => ({
        ...state,
        editor: undefined,
        enhancement: undefined,
        enhancementTypeCurrentOptionsSelector:
          // If we are not on the first step, we reset to the first step.
          // Otherwise, we quit the whole process
          state.enhancement ||
          state.enhancementTypeCurrentOptionsSelector === 'custom'
            ? INITIAL_NUMBER_OF_OPTIONS
            : undefined,
      }),
    }),
    /**
     * TODO:
     */
    selectEnhancementType: store.actions.standalone({
      data: ({ enhancementType }: { readonly enhancementType: string }) => ({
        enhancementType,
        isFinalized: enhancementType !== State.ENHANCEMENT_TYPE_CUSTOM_OPTION,
      }),
      reducer: ({ state, data: { isFinalized } }): State => ({
        ...state,
        enhancementTypeCurrentOptionsSelector:
          // If it is not finalized, that means we are giving the user the
          // opportunity to provide a custom input
          isFinalized ? state.enhancementTypeCurrentOptionsSelector : 'custom',
      }),
    }),
    /**
     * TODO:
     */
    loadEnhancement: store.actions.request({
      input: store.actions.Data.asIs<{ readonly enhancementType: string }>(),
      output: store.actions.Data.asIs<string>(),
      reducers: {
        request: ({ state }): State => ({
          ...state,
          enhancementError: undefined,
          enhancementIsLoading: true,
        }),
        success: ({ state, data: { response } }): State => ({
          ...state,
          enhancement: response,
          enhancementError: undefined,
          enhancementIsLoading: false,
        }),
        cancellation: ({ state }): State => ({
          ...state,
          enhancementError: undefined,
          enhancementIsLoading: false,
        }),
        error: ({ state, data: { error } }): State => ({
          ...state,
          enhancementError: error,
          enhancementIsLoading: false,
        }),
      },
    }),
    /**
     * TODO:
     */
    applyEnhancement: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        success: ({ state }): State => ({
          ...state,
          editor: undefined,
          enhancement: undefined,
          enhancementTypeCurrentOptionsSelector: undefined,
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
